// extracted by mini-css-extract-plugin
export default {"sticky":"ReleaseNotes_sticky__SyGT3","close":"ReleaseNotes_close__tKkNl"};